module.exports = __webpack_public_path__ + "static/media/swedbankMynt.0dabc481.png";